import dataStore from '../../data/data';
import Facemesh from './objects';
import { Canvas } from '@react-three/fiber';
import { Environment,OrbitControls } from '@react-three/drei';
import { useRef } from 'react';

const Editor = () => {
  const cameraRef = useRef();
  const dragging = dataStore(_data => _data.editor.controls.dragging);
  const peerFacemesh = dataStore(_data => _data.mediaprocessing.peer.face.facemesh);
  const vitruvianFacemesh = dataStore(_data => _data.mediaprocessing.vitruvian.face.facemesh);

  return (
    <div>
      <Canvas camera={{ position: [0, 0, 5] }} style={{ width: '100%', height: '100vh' }}>
        <Environment background blur={1} preset='city' />

        <OrbitControls
          enablePan={true}
          enableRotate={!dragging}
          enableZoom={true}
          ref={cameraRef}
          target={[0, 0, 0]}
          initialPosition={[0, 0, 5]}
        />

        <Facemesh
          object={vitruvianFacemesh}
          position={[0, 0, 0]}
        />

        <Facemesh
          object={peerFacemesh}
          position={[4, 0, 0]}
        />
      </Canvas>
    </div>
  );
};

export default Editor;